import { useNavigate } from "react-router-dom";
import axiosInstance from './axiosInstance.js';
import { setActiveToken } from './authStorage.js';

export const fetchOauthLoginLink = (urlCallback) => {
  axiosInstance
  .get(`/getOauthLoginLink`)
  .then((response) => {
    if (response.status === 200) {
      urlCallback(response.data.url);
    } else {
      throw new Error('Failed to fetch oauth login link');
    }
  })
  .catch(error => {
    console.error('Error getting oauth login link:', error);
  });
};
             
export const OauthCallbackHandler = ({onJWTObtained}) => {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  if (!code) {
    console.error("Expected but did not get code from google");
    return
  }

  axiosInstance
  .post(`/provideOauthCode`, { code: code })
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
    console.log("Navigating from oauth to /");
    navigate("/");
  })
  .catch((error) => {
    // /setError(error.message); // Set error state with error message
    console.error("Could not exchange oauth code with jwt token from backend");
  });

  return (
    <div></div>
  )
};

export const ProvideTokenToBackend = ({token, onJWTObtained}) => {
  axiosInstance
  .post(`/provideOauthToken`, { token: token })
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
  })
  .catch((error) => {
    // /setError(error.message); // Set error state with error message
    console.error("Could not exchange oauth code with jwt token from backend");
  });
};

export const ProvideCredentialToBackend = ({credential, onJWTObtained}) => {
  axiosInstance
  .post(`/provideOauthCredential`, { credential: credential })
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
  })
  .catch((error) => {
    // /setError(error.message); // Set error state with error message
    console.error("Could not exchange oauth code with jwt token from backend");
  });
};

export const SendLoginCode = ({identifier, onResult}) => {
  return axiosInstance
  .post(`/sendLoginCode`, { identifier })
  .then((response) => {
    if (onResult) {
      onResult(response.data);
    }
  });
};

export const LoginWithCode = ({identifier, code, onJWTObtained}) => {
  return axiosInstance
  .post(`/loginWithCode`, { identifier, code })
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
  });
};

export const TelegramWebAppAuth = ({initData, onJWTObtained}) => {
  return axiosInstance
  .post(`/tg/webapp/auth`, { initData: initData })
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
  });
};

export const TelegramLoginWidgetAuth = ({tgData, onJWTObtained}) => {
  const body = tgData.id_token
    ? { idToken: tgData.id_token }
    : { code: tgData.code, redirectUri: window.location.origin + '/tg-callback' };
  return axiosInstance
  .post(`/tg/login`, body)
  .then(async (response) => {
    const jwtToken = response.data.token;
    await setActiveToken(jwtToken);
    onJWTObtained();
  });
};

export const LinkTelegram = ({tgData, confirm}) => {
  return axiosInstance
  .post(`/user/linkTelegram`, { idToken: tgData.id_token, confirm: !!confirm })
  .then((response) => response.data);
};

